import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { GetApplicationAPI } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const application = createAsyncThunk('get/application', GetApplicationAPI);

export const ApplicationSlice = createSlice({
	name: 'application',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[application.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[application.rejected.toString()]: setAPIError,
		[application.fulfilled.toString()]: (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION<any>) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = action.payload;
		},
	},
});

interface IStates {
	[ApplicationSlice.name]: ReturnType<typeof ApplicationSlice.reducer>;
}

export const applicationSelector = (state: IStates): any => {
	return state[ApplicationSlice.name] || {};
};

export const useApplication = (): any => useSelector(applicationSelector);

export const getApplication =
	(params: any) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(application(params));
		return;
	};

export const resetApplication =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(ApplicationSlice.actions.RESET());
		return;
	};
